// extracted by mini-css-extract-plugin
export default {"header__description":"ServicesBillsReport_header__description__QgBsw","content__empty":"ServicesBillsReport_content__empty__l0zZ5","detail":"ServicesBillsReport_detail__DUmeW"};